import { BoxProps, HStack, useColorMode } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { AdaptationMode } from '../../../components/layout/PageLayout';
import CustomButton from '../../../iZUMi-UI-toolkit/src/components/Buttons/CustomButton/CustomButton';
import { getColorThemeSelector } from '../../../utils/funcs';

type Props = {
    dex: 'iZi' | 'uni' | 'bella';
    type?: AdaptationMode;
} & BoxProps;

const TypeSelect: React.FC<Props> = (props) => {
    const { type } = props;
    const { t } = useTranslation();
    const colorTheme = getColorThemeSelector(useColorMode().colorMode);
    const { dex, ...rest } = props;
    const history = useHistory();
    const location = useLocation();

    return type === 'mobile' ? (
        <HStack w="342px" alignItems="start" justifyContent="start" spacing="15px" {...rest}>
            <CustomButton
                bg={location.pathname === `/farm/${dex}/dynamic` ? 'linear-gradient(93.8deg, #8755FF 2.26%, #5829C8 112.45%)' : 'inherit'}
                _selected={{}}
                border="none"
                color={location.pathname === `/farm/${dex}/dynamic` ? '#ffffff' : '#9E96AF'}
                fontFamily={location.pathname !== `/farm/${dex}/dynamic` ? 'Montserrat' : 'Montserrat-Bold'}
                onClick={() => {
                    location.pathname !== `/farm/${dex}/dynamic` && history.push(`/farm/${dex}/dynamic`);
                }}
                borderRadius="3px"
                text={t('Dynamic')}
                h="25px"
                w="80px"
                fontSize="12px"
                letterSpacing="0.02em"
            />
            <CustomButton
                bg={location.pathname === `/farm/${dex}/fix` ? 'linear-gradient(93.8deg, #8755FF 2.26%, #5829C8 112.45%)' : 'inherit'}
                border="none"
                _selected={{}}
                color={location.pathname === `/farm/${dex}/fix` ? '#ffffff' : '#9E96AF'}
                fontFamily={location.pathname !== `/farm/${dex}/fix` ? 'Montserrat' : 'Montserrat-Bold'}
                onClick={() => {
                    location.pathname !== `/farm/${dex}/fix` && history.push(`/farm/${dex}/fix`);
                }}
                borderRadius="3px"
                text={t('Fix Range')}
                h="25px"
                w="80px"
                fontSize="12px"
            />

            <CustomButton
                bg={location.pathname === `/farm/${dex}/one-side` ? 'linear-gradient(93.8deg, #8755FF 2.26%, #5829C8 112.45%)' : 'inherit'}
                border="none"
                _selected={{}}
                color={location.pathname === `/farm/${dex}/one-side` ? '#ffffff' : '#9E96AF'}
                fontFamily={location.pathname !== `/farm/${dex}/one-side` ? 'Montserrat' : 'Montserrat-Bold'}
                onClick={() => {
                    location.pathname !== `/farm/${dex}/one-side` && history.push(`/farm/${dex}/one-side`);
                }}
                borderRadius="3px"
                text={t('One Side')}
                h="25px"
                w="80px"
                fontSize="12px"
            />
        </HStack>
    ) : (
        <HStack
            w="100%"
            alignItems="start"
            //justifyContent={{ base: 'space-between' }}
            justifyContent="end"
            spacing="20px"
            {...rest}
        >
            <CustomButton
                // variant={location.pathname === `/farm/${dex}/fix` ? 'purple' : 'outlinePurple'}
                onClick={() => {
                    location.pathname !== `/farm/${dex}/fix` && history.push(`/farm/${dex}/fix`);
                }}
                bg={location.pathname === `/farm/${dex}/fix` ? '#4CB0F3' : ''}
                color={location.pathname === `/farm/${dex}/fix` ? '#FFFFFF' : '#CCDCE2'}
                border="1px solid #CCDCE2"
                borderRadius="6px"
                text={t('Fix Range')}
                h="30px"
                w="130px"
                px="10px"
                fontSize="12px"
            />

            {/* <CustomButton
                // variant={location.pathname === `/farm/${dex}/one-side` ? 'purple' : 'outlinePurple'}
                onClick={() => {
                    location.pathname !== `/farm/${dex}/one-side` && history.push(`/farm/${dex}/one-side`);
                }}
                bg={location.pathname === `/farm/${dex}/one-side` ? '#4CB0F3' : ''}
                color={location.pathname === `/farm/${dex}/one-side` ? '#FFFFFF' : '#CCDCE2'}
                border="1px solid #CCDCE2"
                borderRadius="6px"
                text={t('One Side')}
                h="30px"
                w="130px"
                px="10px"
                fontSize="12px"
            /> */}

            <CustomButton
                // variant={location.pathname === `/farm/${dex}/dynamic` ? 'purple' : 'outlinePurple'}
                onClick={() => {
                    location.pathname !== `/farm/${dex}/dynamic` && history.push(`/farm/${dex}/dynamic`);
                }}
                bg={location.pathname === `/farm/${dex}/dynamic` ? '#4CB0F3' : ''}
                color={location.pathname === `/farm/${dex}/dynamic` ? '#FFFFFF' : '#CCDCE2'}
                border="1px solid #CCDCE2"
                borderRadius="6px"
                text={t('Dynamic')}
                h="30px"
                w="130px"
                px="10px"
                fontSize="12px"
            />
        </HStack>
    );
};

export default TypeSelect;
